import { Badge, HStack, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { FC } from 'react'
import { userAdminType } from '../../techRaffles/types'
import { AdminUserStateAndFlagButtons } from './AdminUserFlagBox'

export const AdminUserInfoAndFlagBox: FC<{ user: userAdminType }> = ({
  user,
}) => {
  return (
    <VStack w='100%'>
      <Text
        width='100%'
        textAlign={'center'}
        fontSize='1rem'
        isTruncated
        fontWeight={600}
      >
        Hosted by {user.name}
      </Text>

      <Link w='100%' href={'/u/' + user.wallet} target='_blank'>
        <Text
          width='100%'
          textAlign={'center'}
          fontSize='0.75rem'
          fontWeight={500}
        >
          {user.wallet}
        </Text>
      </Link>
      <Text fontSize='0.875rem'>
        Raffles: {user._count.createdRaffles} created /{' '}
        {user._count.participants} participated /{' '}
        {user._count.wonRaffles} won
      </Text>
      <HStack>
        {user.hasBeenBanned && (
          <Badge colorScheme={'red'}>Banned</Badge>
        )}
        {user.hasBeenFlagged && (
          <Badge colorScheme={'yellow'}>Flagged</Badge>
        )}
        {user.isShadowBanned && (
          <Badge colorScheme={'gray'}>Shadow banned</Badge>
        )}
        {user.internalFlagged && (
          <Badge colorScheme={'blue'}>Internal flag</Badge>
        )}
      </HStack>
      <SimpleGrid spacing='1rem' columns={[2]}>
        <AdminUserStateAndFlagButtons userWallet={user.wallet} />
      </SimpleGrid>
    </VStack>
  )
}

export default AdminUserInfoAndFlagBox
